<template>
  <div v-if="status">
    <div class="row pl-2">
      <div class="col-md-6 col-sm-6 col-lg-3 p-0 card-deck pt-3">
        <div class="card taphi fh-200">
          <div class="card-body">
            <h5 class="card-title dash-title">Total Antrean Pasien Hari ini</h5>
            <div class="_img_text-rp-new bigger">
              {{ dashboardData.pasien_hari_ini || 0 }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-lg-3 p-0 card-deck pt-3">
        <div class="card jpbhi fh-200">
          <div class="card-body">
            <h5 class="card-title dash-title">Jumlah Pasien Baru Hari ini</h5>
            <div class="_img_text-rp-new bigger">
              {{  dashboardData.pasien_baru_hari_ini || 0 }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-lg-3 p-0 card-deck pt-3">
        <div class="card tphi fh-200">
          <div class="card-body">
            <h5 class="card-title dash-title">Total Pendapatan Hari ini</h5>
            <div class="_img_text-rp-new">
              {{ dashboardData.total_pendapatan_hari_ini || `RP. 0,-` }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-lg-3 p-0 card-deck pt-3">
        <div class="card tpbi fh-200">
          <div class="card-body align-items-stretch">
            <h5 class="card-title dash-title">Total Pendapatan Bulan ini</h5>
            <div class="_img_text-rp-new">
              {{ dashboardData.total_pendapatan_bulan_ini || `RP. 0,-` }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row p-1 mt-3">
      <div :class="surveyKepuasan && satusehatAuthValid ? 'col-md-5' : 'col-md-6'" class="mb-3-custom">
        <div class="card h-100">
          <div class="card-body">
            <p class="m-0">
              <b>Tahun {{ year }}</b>
            </p>
            <strong style="font-size:20px">Total Kunjungan Pasien</strong>
            <BarChart
              :data-bar="barChartData"
              class="__zoom_kunjungan_pasien"
            />
          </div>
        </div>
      </div>
      <div :class="surveyKepuasan && satusehatAuthValid ? 'col-md-5' : 'col-md-6'" style="padding-left: 0px;" class="mb-3-custom">
        <div class="card h-100">
          <div class="card-body">
            <strong style="font-size:20px">Status Antrean Pasien</strong>
            <div class="row">
              <div class="col-md-7 col-sm-6">
                <PieChart
                  :data-pie="pieChartData"
                  style="zoom:125%;height:250px;"
                />
              </div>
              <div
                class="col-md-5 col-sm-6 p-0 d-flex align-items-center zoom-text"
              >
                <ul>
                  <li class="mt-3 waiting">
                    <b>Menunggu</b> <br />
                    {{
                      `${dashboardData.waiting_percentace}% (${dashboardData.total_waiting} Pasien)`
                    }}
                  </li>
                  <li class="mt-3 consultation">
                    <b>Konsultasi</b> <br />
                    {{
                      `${dashboardData.in_consultation_percentace}% (${dashboardData.total_in_consultation} Pasien)`
                    }}
                  </li>
                  <li class="mt-3 finish">
                    <b>Selesai</b> <br />
                    {{
                      `${dashboardData.has_been_consultation_percentace}% (${dashboardData.total_has_been_consultation} Pasien)`
                    }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-2 col-kepuasan" v-if="surveyKepuasan && satusehatAuthValid">
        <div class="card h-100">
          <div class="card-body card-body-qr-kepuasan d-flex justify-content-center align-items-center">
            <img class="img-fluid" :src="imageSrc" alt="icon-pasien-hari-ini" />
          </div>
          <div class="card-footer card-footer-qr-kepuasan">
            <div class="row">
              <div class="col-sm-12">
                <button type="button" class="btn btn-primary btn-sm btn-qr-kepuasan mb-2" @click.prevent="donwloadImage(surveyKepuasan)">
                  Download
                </button>
              </div>
              <div class="col-sm-12">
                <button type="button" class="btn btn-show btn-sm btn-qr-kepuasan" @click.prevent="readFile(surveyKepuasan)">
                  Show
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-row class="mt-3">
      <top-diagnosis />
      <b-col sm="12" lg="4">
        <b-card id="top-ten-action">
          <b-card-body class="pl-0 pr-0">
            <b-row>
              <b-col>
                <strong style="font-size:20px">Top 10<br/>Tindakan</strong>
              </b-col>
              <b-col sm="7 text-right align-items-end">
                  <span style="font-size: 11pt;"><strong>Pilih Periode:</strong></span>
                  <div>
                      <date-picker v-model="periodAction"
                          type="month"
                          format="MMMM YYYY"
                          value-type="YYYY-MM"
                          placeholder="MMMM YYYY"
                          style="width: 100%;"
                          @input="periodActionChange()">
                      </date-picker>
                  </div>
              </b-col>
            </b-row>
            
            <div class="table-responsive">
              <b-table hover :items="topTenTindakan" :fields="fiedls" class="mt-2">
                <template v-slot:cell(total)="data">
                  <p class="text-right">{{ data.item.total }}</p>
                </template>
              </b-table>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <LaporanPendapatan />
      </b-col>
    </b-row>
    <b-row v-if="bpjsAuthValid">
      <b-col sm="12">
        <LaporanPendapatanBPJS />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <LaporanPenjualan />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import "vue2-datepicker/index.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBell } from "@fortawesome/free-solid-svg-icons";

library.add(faBell);

export default {
  data() {
    return {
      year: new Date().getFullYear(),
      periodAction: moment(new Date()).format('YYYY-MM'),
      dashboardData: {},
      dataPaket: {},
      barChartData: [
        {
          label: "Pasien",
          backgroundColor: "#c6d9ff",
          borderColor: "#c6d9ff",
          data: [],
          borderWidth: 5,
          borderRadius: {
            topLeft: 10,
            topRight: 10
          },
          borderSkipped: false
        }
      ],
      pieChartData: [
        {
          backgroundColor: ["#ffbc6e", "#6b9eff", "#c3aff5"],
          data: [],
          cutout: "75%"
        }
      ],
      status: false,
      fiedls: [
        {
          key: 'kode',
          label: 'Kode' 
        },
        {
          key: 'nama',
          label: 'Nama Tindakan' 
        },
        {
          key: 'total',
          label: 'Jumlah',
          thClass: 'text-right'
        }
      ],
      topTenTindakan: [],
      surveyKepuasan: null,
      screenWidth: window.innerWidth,
    };
  },
  components: {
    BarChart: () => import("@/views/Home/BarChart"),
    PieChart: () => import("@/views/Home/PieChart"),
    LaporanPendapatan: () => import("@/views/Home/LaporanPendapatanKlinik"),
    LaporanPendapatanBPJS: () => import("@/views/Home/LaporanPendapatanBPJS"),
    LaporanPenjualan: () => import("@/views/Home/LaporanPenjualanKlinik"),
    DatePicker,
    'top-diagnosis': () => import("@/views/Home/TopDiagnosis")
  },
  computed: {
    ...mapGetters({
      getKlinikId: "getKlinikId",
      bpjsAuthValid: "bpjsAuthValid",
      satusehatAuthValid: "satusehatAuthValid",
    }),
    imageSrc() {
      return this.screenWidth <= 1366
        ? require("./../../assets/img/survey_kepuasan_lg.png") // iPad image
        : require("./../../assets/img/survey_kepuasan.png"); // Default image
    }
  },
  created() {
    this.fetchData();
    this.fetchTopTenTindakan();
    this.fetchDataSurveyKepuasan();
  },
  mounted() {
    window.addEventListener("resize", this.updateScreenWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateScreenWidth);
  },
  methods: {
    async fetchTopTenTindakan() {
        let path = `top-ten-tindakan?klinik_id=${this.getKlinikId}`
        if(this.periodAction) {
          path += `&month=${moment(this.periodAction).format('YY-MM')}`
        }
        const response = await this.$axios.get(path);
        this.topTenTindakan = response.data.data;
    },
    async fetchData() {
      const is_owner = false;
      const res = await this.$axios.get(
        `dash-pasien?klinik_id=${this.getKlinikId}&is_owner=${is_owner}`
      );
      const { data } = res.data;
      this.dashboardData = data;

      // paket
      this.dataPaket = {
        punya_paket: data.data_subscribe.nama_paket != '' ? true : false,
        nama_paket: data.data_subscribe.nama_paket,
        limit_paket: data.data_subscribe.limit_paket,
        durasi_paket: data.data_subscribe.durasi_paket,
        sisa_kouta: data.data_subscribe.sisa_kouta,
        tanggal_mulai: data.data_subscribe.tanggal_mulai,
        habis_berlaku: data.data_subscribe.habis_berlaku,
        sisa_hari: data.data_subscribe.sisa_hari,
        is_new: data.data_subscribe.is_new
      };

      // bar chart
      let barData = data.kunjungan_pasien_perbulan.map(item => {
        return item[1];
      });
      this.barChartData[0].data = barData;

      // doughnut chart
      let total =
        data.waiting_percentace +
        data.in_consultation_percentace +
        data.has_been_consultation_percentace;
      if (total > 0) {
        this.pieChartData[0].data = [
          data.waiting_percentace,
          data.in_consultation_percentace,
          data.has_been_consultation_percentace
        ];
      } else {
        this.pieChartData[0].backgroundColor = ["#eeeeee"];
        this.pieChartData[0].data = [0.1];
      }
      this.status = true;
      this.colorBar();
    },
    colorBar() {
      let color = [];
      let month = new Date().getMonth();
      for (let i = 0; i < 12; i++) {
        if (i == month) color.push("#4a85fb");
        else if (i > month) color.push("#1C00ff00");
        else color.push("#c6d9ff");
      }
      this.barChartData[0].backgroundColor = color;
      this.barChartData[0].borderColor = color;
    },
    matchRound(num) {
      return Math.round(num);
    },
    periodActionChange() {
      this.fetchTopTenTindakan();
    },
    async fetchDataSurveyKepuasan() {
      try {
        const res = await this.$axios.get(
          `/qrcode-kepuasan-pasien/get?klinik_id=${this.getKlinikId}`
        );
        const { status, data } = res.data;
        if (status) {
          const files = data
          this.surveyKepuasan = files[0]
        }
      } catch (e) {
        // console.log(e);
      }
    },
    async donwloadImage(item) {
      const a = document.createElement('a');
        a.href = await this.toDataURL(item.url);
        a.download = item.name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    },
    toDataURL(url) {
      return fetch(url).then((response) => {
          return response.blob();
      }).then(blob => {
          return URL.createObjectURL(blob);
      });
    },
    readFile(item) {
      window.open(item.url)
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    }
  },
};
</script>

<style>
.izd-dashboard-table th {
  border-top: 0px;
  background-color: transparent !important;
  text-transform: none;
}

.__zoom_kunjungan_pasien {
  transform: scale(1);
  /* width: 132%; */
  /* margin-left: -16%; */
  height: 300px !important;
  margin-top: 3px !important;
}

</style>

<style scoped>

.h-min {
  min-height: 405px;
}

.card-body-qr-kepuasan {
  padding-top: 1.00rem;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  padding-bottom: 0.10rem;
}

.col-kepuasan {
  padding-left: 0px;
}

.card-footer-qr-kepuasan {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

/* For Ipad */
@media (min-width: 768px) and (max-width: 1180px) {
  .card-body-qr-kepuasan {
    padding-top: 1.00rem;
    padding-left: .25rem;
    padding-right: .25rem;
    padding-bottom: 0.10rem;
  }

  .col-kepuasan {
    padding-left: 0px;
    margin-left: -5px;
    padding-right: 5px;
  }

  .card-footer-qr-kepuasan {
    padding-left: 0.3rem !important;
    padding-right: 0.3rem !important;
  }
}

@media (max-width: 750px) {
  .card-body-qr-kepuasan {
    padding-top: 1.00rem;
    padding-left: .25rem;
    padding-right: .25rem;
    padding-bottom: 0.10rem;
  }

  .mb-3-custom {
    margin-bottom: 1rem !important;
  }
}

.notif-sip {
  max-height: 350px;
  font-size: 14px;
  overflow-y: auto;
}

._img_text_sub {
  position: absolute !important;
  font-size: 20px;
  color: beige;
  font-weight: 650;
  margin-top: 7%;
  padding-left: 7%;
  padding-right: 7%;
  z-index: 1;
}

._img_text {
  position: absolute !important;
  font-size: 4.8em;
  color: beige;
  font-weight: 650;
  margin-top: 10%;
  padding-left: 7%;
  z-index: 1;
}

._img_text-rp {
  position: absolute !important;
  font-size: 33px;
  color: beige;
  font-weight: 650;
  margin-top: 19.3%;
  margin-bottom: auto;
  padding-left: 7%;
  text-align: center;
  z-index: 1;
}

._img_text-rp-new {
  font-size: 33px;
  color: beige;
  font-weight: 650;
  text-align: left;
}

.bigger {
  font-size: 85px;
}

.dash-title {
  color: beige;
  font-weight: 650;
  font-size: 15px;
}

.taphi {
  background-image: url("./../../assets/img/background_1.png");
  object-fit: none;
}

.jpbhi {
  background-image: url("./../../assets/img/background_2.png");
  object-fit: none;
}

.tphi {
  background-image: url("./../../assets/img/background_4.png");
  object-fit: none;
}

.tpbi {
  background-image: url("./../../assets/img/background_3.png");
  object-fit: none;
}

ul {
  list-style: none;
}

ul li.waiting::before {
  content: "\2022";
  color: #ffbc6e;
  font-weight: bold;
  font-size: 2rem;
  display: inline-block;
  width: 1em;
  margin-left: -1em;
}

ul li.consultation::before {
  content: "\2022";
  color: #6b9eff;
  font-weight: bold;
  font-size: 2rem;
  display: inline-block;
  width: 1em;
  margin-left: -1em;
}

ul li.finish::before {
  content: "\2022";
  color: #c3aff5;
  font-weight: bold;
  font-size: 2rem;
  display: inline-block;
  width: 1em;
  margin-left: -1em;
}

@media only screen and (max-width: 1400px) and (min-width: 1220px) {
  .h-min {
    min-height: 410px;
  }

  .notif-sip {
    max-height: 410px;
    font-size: 14px;
    overflow-y: auto;
  }

  ._img_text_sub {
    position: absolute !important;
    font-size: 16px;
    color: beige;
    font-weight: 650;
    margin-top: 7%;
    padding-left: 7%;
    /* padding-right: 7%; */
    z-index: 1;
  }

  ._img_text {
    position: absolute !important;
    font-size: 4.5em;
    color: beige;
    font-weight: 650;
    margin-top: 10%;
    padding-left: 7%;
    z-index: 1;
  }

  ._img_text-rp {
    position: absolute !important;
    font-size: 33px;
    color: beige;
    font-weight: 650;
    margin-top: 19.3%;
    margin-bottom: auto;
    padding-left: 7%;
    text-align: center;
    z-index: 1;
  }

  .zoom-text {
    zoom: 87%;
  }
}

.card-deck {
  margin-right: 0px;
  margin-left: 0px;
}

.fh-200 {
  height: 200px;
}

.btn-show {
  color: #fff;
  background-color: #0d74df;
  border-color: #0d74df;
}
.btn-show {
    box-shadow: 0 0.25rem 0.55rem rgba(60, 68, 177, 0.35);
}

.btn-qr-kepuasan {
  width: 100%;
}
</style>
